// extracted by mini-css-extract-plugin
export default {"legalBox":"SignupCard_legalBox__98rSE","inlineModalLink":"SignupCard_inlineModalLink__YJO5m"};